import { useInactivityTimer } from '../hooks/useInactivityTimer';

const InactivityHandler = () => {
  useInactivityTimer();
  return null;
};

export default InactivityHandler;